<template>
    <el-dialog width="600px" title="快递单号查询" v-model="isvisible">
        <div class="container offset-bottom">
            <div style="height:100%;padding-top:44px;"> {{ flowSrc }}
                <iframe :src="flowSrc" style="height:100%; width:100%;margin:0;border:0;"> </iframe>
            </div>
        </div>
  
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeDialog">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </template>
    <script setup>
  import { ref, defineExpose } from "vue";
  //defineEmits
  let timer;
    
//   const emit = defineEmits(["click"]); // 声明父触发事件
  
  
  const flowSrc = ref('');

  const isvisible = ref(false);
  const changeVisible = (v) => {
    isvisible.value = v;
  }; 
  
  const orderExpressMethod = (obj) => {
    console.log('iframe order finance---:',obj.expressnum)

    flowSrc.value = 'https://m.kuaidi100.com/app/query/?coname=cg&nu='+obj.expressnum
    console.log(flowSrc.value)
  };
  
  defineExpose({ changeVisible, orderExpressMethod });
  
  
  const closeDialog = () => {
    isvisible.value = false;
    clearTimeout(timer);
  };
  
  </script>
    <style scoped>
  .el-dialog {
    text-align: left;
  }
  .el-dialog__body {
    padding-top: 15px;
  }
  </style>